import { Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";


const FormikCheckbox: React.FC<FormikCheckboxProps> = ({label, clasName, fieldName, disabled}) => {
  const { t } = useTranslation();
  
  return (
    <>
      <label className="form-label">
        {`${t(label)}`}
      </label>

      <Field
        name={fieldName}
        className={clasName}
        type="checkbox"
        field={fieldName}
        disabled={disabled}
      />

      <div className="text-danger">
        <ErrorMessage name={fieldName} component="div" />
      </div>
    </>
  )
}

export default FormikCheckbox;

type FormikCheckboxProps = {
  label: string,
  fieldName: string,
  clasName?: string,
  disabled?: boolean
}

const defaultProps: Partial<FormikCheckboxProps> = {
  clasName: "",
  disabled: false
}

FormikCheckbox.defaultProps = defaultProps;
